export async function handleContactsConnect() {
  return window.mainProcessApi.connectContacts();
}

export async function handleOpenContactsSettings() {
  return window.mainProcessApi.openContactsSettings();
}
